import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

export const pricingRuleStore = defineStore('pricingRule', {
  id: 'pricingRule',
  state: () => ({
    loading: {
      rules: false,
      effective: false,
      saving: false,
      preview: false
    },
    rules: [],
    effective: [],
    preview: []
  }),
  actions: {
    reset() {
      this.rules = []
      this.effective = []
      this.preview = []
    },
    clearPreview() {
      this.preview = []
    },
    async getPreview(firm, insurance) {
      this.loading.preview = true
      try {
        const results = await api.get(`pricingRule/preview?firm=${firm}&insurance=${insurance}`)
        this.preview = Array.isArray(results) ? results : []
      } finally {
        this.loading.preview = false
      }
      return this.preview
    },
    async getRules(firm, insurance = null) {
      if (firm === undefined || firm === null) {
        this.rules = []
        return this.rules
      }
      this.loading.rules = true
      try {
        let url = `pricingRule?firm=${firm}&includeInherited=false`
        if (insurance) {
          url += `&insurance=${insurance}`
        }
        const results = await api.get(url)
        this.rules = Array.isArray(results) ? results : []
      } finally {
        this.loading.rules = false
      }
      return this.rules
    },
    async getEffectiveRules(firm) {
      if (firm === undefined || firm === null) {
        this.effective = []
        return this.effective
      }
      this.loading.effective = true
      try {
        const results = await api.get(`pricingRule/effective?firm=${firm}`)
        this.effective = Array.isArray(results) ? results : []
      } finally {
        this.loading.effective = false
      }
      return this.effective
    },
    async saveRule(rule) {
      this.loading.saving = true
      try {
        await api.post('pricingRule', rule)
        await this.getRules(rule.firm)
        await this.getEffectiveRules(rule.firm)
      } finally {
        this.loading.saving = false
      }
    },
    async deleteRule(pricingRule, firm) {
      this.loading.saving = true
      try {
        await api.delete(`pricingRule/${pricingRule}`)
        await this.getRules(firm)
        await this.getEffectiveRules(firm)
      } finally {
        this.loading.saving = false
      }
    }
  }
})
